import React from "react";

const RebrandFooter: React.FC = () =>
  React.createElement("elexon-global-footer", {
    "show-design-by": "false",
    "show-using-this-website": "false",
  });

export default RebrandFooter;
